import React, { useState } from "react";
import { Link } from "react-router-dom";
import Cart from "../contents/home/cart/Cart";
import { IoCartOutline } from "react-icons/io5";
import { getDataCart } from '../functions/cart'

const Navbar: React.FC = () => {
    const [cartData, setCartData] = useState<any[]>([]);

    const handleOpen = async () => {
        const open_modal = document.getElementById('my_modal_2') as HTMLDialogElement
        open_modal.showModal()
        await getDataCart(setCartData)

        console.log(cartData)
    }

    const refreshCartData = async () => {
        await getDataCart(setCartData);
    }

    return (
        <>
            <div className="border border-b-2">
                <div className="bg-[#f0f3f2!important] py-1">
                    <div className="max-w-[1140px] mx-auto">
                        <div>
                            <span>Super Value Deals - Save more with coupons</span>
                        </div>
                    </div>
                </div>
                <div className="max-w-[1140px] mx-auto">
                    <nav className="hidden lg:inline bg-white border-gray-200 dark:bg-gray-900 mt-5 sticky top-0 z-50">
                        <div className="max-w-screen bg-white">
                            <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
                                <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
                                    <img src="https://flowbite.com/docs/images/logo.svg" className="h-10" alt="Logo" />
                                </Link>
                                <button data-collapse-toggle="navbar-default" type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-default" aria-expanded="false">
                                    <span className="sr-only">Open main menu</span>
                                    <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15" />
                                    </svg>
                                </button>
                                <div className="hidden w-full md:block md:w-auto" id="navbar-default">
                                    <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700 ">
                                        <li>
                                            <a href="#" className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-500 md:p-0 dark:text-white md:dark:hover:text-orange-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Home</a>
                                        </li>
                                        <li>
                                            <a href="#" className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-500 md:p-0 dark:text-white md:dark:hover:text-orange-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">About</a>
                                        </li>
                                        <li>
                                            <a href="#" className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-500 md:p-0 dark:text-white md:dark:hover:text-orange-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Services</a>
                                        </li>
                                        <li>
                                            <a href="#" className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-500 md:p-0 dark:text-white md:dark:hover:text-orange-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Pricing</a>
                                        </li>
                                        <li>
                                            <a href="#" className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-500 md:p-0 dark:text-white md:dark:hover:text-orange-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Contact</a>
                                        </li>
                                        <li>
                                            <a href="#" className="block py-2 px-3 text-3xl  text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-500 md:p-0 dark:text-white md:dark:hover:text-orange-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent" onClick={handleOpen}><IoCartOutline></IoCartOutline></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </nav>
                </div>

            </div>
            <Cart cartData={cartData} refreshCartData={refreshCartData} ></Cart>
        </>

    )
}

export default Navbar